import { ENUMS } from '../utils/constants';
import { isNullOrEmpty } from '../utils/util';

const INITIAL_STATE = {
    logs: [],
    missionList: [],
    suppliers: [],
    parts: [],
    routes: [],
    route: {},
    routeUsers: [],
    routeUser: {},
    orders: {
        hasNextPage: false,
        hasPreviousPage: false,
        indexFrom: 0,
        items: [],
        pageIndex: 0,
        pageSize: 10,
        totalCount: 0,
        totalPages: 0
    },
    order: {},
    mission: {},
    filter: {
        orderCode: undefined,
        orderItemCode: undefined,
        cim: undefined,
        partnumber: undefined,
        supplierCode: undefined,
        orderType: undefined,
        route: undefined,
        status: [ENUMS.eOrderStatus.Waiting.value, ENUMS.eOrderStatus.InProgress.value,
        ENUMS.eOrderStatus.WaitingRouteComposition.value]
    },
    invoicesFile: [],
    invoiceFile: {},
    cimFile: {}
};

export default function pickingReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'LIST_INVOICES_FILE':
            return {
                ...state,
                invoicesFile: action.invoicesFile,
            };
        case 'SET_INVOICE_FILE':
            return {
                ...state,
                invoiceFile: action.invoiceFile

            };
        case 'LIST_MISSION':
            return {
                ...state,
                missionList: action.missionList,
            };
        case 'PICKING_SUPPLIERS':
            return {
                ...state,
                suppliers: action.suppliers,
            };
        case 'PICKING_PARTS':
            return {
                ...state,
                parts: action.parts,
            };
        case 'PICKING_ROUTES':
            return {
                ...state,
                routes: action.routes,
            };
        case 'SET_ROUTE':
            return {
                ...state,
                route: action.route,
            };
        case 'PICKING_ROUTE_USERS':
            return {
                ...state,
                routeUsers: action.routeUsers

            };
        case 'SET_ROUTE_USER':
            return {
                ...state,
                routeUser: action.routeUser

            };
        case 'PICKING_ORDERS':
            return {
                ...state,
                orders: action.orders,
            };
        case 'PICKING_SELECT_ORDER':
            return {
                ...state,
                order: action.order,
            };
        case 'PICKING_FILTER':
            return {
                ...state,
                filter: action.filter,
            };
        case 'RESET_PICKING_FILTER': {
            // TODO: WILSON, POR ALGUM MOTIVO O INITIAL STATE ESTÁ COMO O STATE (PREENCHIDO)
            // POR ISSO NÃO ESTAVA LIMPANDO
            return {
                ...state,
                filter: {
                    orderCode: undefined,
                    orderItemCode: undefined,
                    cim: undefined,
                    partnumber: undefined,
                    supplierCode: undefined,
                    orderType: undefined,
                    route: undefined,
                    status: [ENUMS.eOrderStatus.Waiting.value, ENUMS.eOrderStatus.InProgress.value,
                    ENUMS.eOrderStatus.WaitingRouteComposition.value]
                }
            };
        }
        case 'PICKING_SELECT_MISSION':
            return {
                ...state,
                mission: action.mission,
            };
        case 'UPDATE_MISSION_STATUS': {
            try {
                const missionUpdate = state.order.items.find((m) => m.orderItemId === action.orderItemId);
                missionUpdate.status = action.status;

                return state;
            } catch (error) {
                return {
                    ...state,
                };
            }
        }
        case 'UPDATE_ORDER_STATUS': {
            const orderUpdate = state.orders.items.find((m) => m.orderId === action.orderId);
            orderUpdate.status = action.status;

            return state;
        }
        case 'RESET_ORDER':
            return {
                ...state,
                order: INITIAL_STATE.order
            };
        case 'RESET_ORDERS':
            return {
                ...state,
                orders: INITIAL_STATE.orders
            };
        case 'PICKING_UPDATE_ORDER': {
            const orders = state.orders;

            const order = orders.items.find((o) => o.orderId === action.order.orderId);
            if (order) {
                if (action.order.status !== ENUMS.eOrderStatus.Canceled.value
                    && action.order.status !== ENUMS.eOrderStatus.Finished.value
                    && action.order.status !== ENUMS.eOrderStatus.ManuallyFinished.value) {
                    Object.assign(order, action.order);
                } else {
                    orders.items = orders.items.filter((o) => o.orderId !== action.order.orderId);
                    orders.totalCount -= 1;
                }
            }
            return {
                ...state,
                orders
            };
        }
        case 'PICKING_UNBLOCK_ORDER': {
            const orders = state.orders;

            const order = orders.items.find((o) => o.orderId === action.orderId);
            order.status = ENUMS.eOrderStatus.Waiting.value;
            order.startedBy = '';
            order.startedOn = '';

            return {
                ...state,
                orders
            };
        }
        case 'PICKING_REMOVE_ORDER': {
            const ordersState = state.orders;

            const order = ordersState.items.find((o) => o.orderId === action.orderId);
            if (!isNullOrEmpty(order)) {
                ordersState.items = ordersState.items.filter((o) => o.orderId !== action.orderId);
            }

            return {
                ...state,
                orders: ordersState
            };
        }
        case 'PICKING_UNBLOCK_ORDER_ITEM': {
            const order = state.orders.items.find((o) => o.orderId === action.orderId);
            if (order) {
                const missionUpdate = order.items.find((m) => m.orderItemId === action.orderItemId);
                if (missionUpdate) {
                    missionUpdate.status = ENUMS.eOrderItemStatus.Waiting.value;
                    missionUpdate.startedBy = '';
                    missionUpdate.startedOn = '';
                }
            }

            return {
                ...state,
                order
            };
        }
        case 'PICKING_CHANGEUSER_ORDER': {
            const orders = state.orders;

            const order = orders.items.find((o) => o.orderId === action.orderId);
            order.startedBy = action.newUser;
            order.startedOn = new Date().toISOString();

            return {
                ...state,
                orders
            };
        }
        case 'UPDATE_LOGS': {
            return {
                ...state,
                logs: action.logs,
            };
        }
        case 'SET_CIM_FILE':
            return {
                ...state,
                cimFile: action.cimFile
            };
        case 'SELECT_CIM_FILE_ITEM':
            return {
                ...state,
                cimFileItem: action.cimFileItem
            }
        default:
            return state;
    }
}
